import React from 'react'
import FilterChipGroup from "@techsoftware/happay-widgets/FilterChipGroup";

const CustomFilterChipGroup = (props) => {
  return (
    <FilterChipGroup {...props} />
  )
}

export default CustomFilterChipGroup;
